import { render, staticRenderFns } from "./designEditor_m.vue?vue&type=template&id=0c328a54&"
import script from "./designEditor_m.vue?vue&type=script&lang=ts&"
export * from "./designEditor_m.vue?vue&type=script&lang=ts&"
import style0 from "./designEditor_m.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports